import React from 'react';
import PayzenCashoutDetails from 'app/components/cashout/PayzenCashoutDetails';
import FieldWrapSelectPicker from 'app/components/cashout/FieldWrapSelectPicker';
import FieldWrapInput from 'app/components/cashout/FieldWrapInput';

export default class IndonesiaCashoutDetails extends PayzenCashoutDetails {
    state = {
        bank_id: '',
        customer_name: ''
    };

    get bankList() {
        const {china_banks = []} = this.props;
        return china_banks.filter(b => b.country_code === 'indonesia' &&
            b.method === 'payout');
    }

    render() {
        const {disabled, errors} = this.props;

        return <div className="cashout__field field">
            <FieldWrapInput
                stateName="customer_name"
                handleOnChange={this.handleOnChange}
                value={this.state.customer_name}
                disabled={disabled}
                errors={errors}
            />

            <FieldWrapSelectPicker
                collection={this.bankList}
                value={this.state.bank_id}
                stateName="bank_id"
                attrValue="bank_id"
                translation_key="bank"
                attrDescription="description"
                handleOnChange={this.handleSelect}
                disabled={disabled}
                errors={errors}
            />
        </div>;
    }
}
